import convertHtmlToReact from '@hedgedoc/html-to-react'
import { useState } from 'react'
import { PopoverV2, kuiperClassNames, renderIcon } from '@opallabs/kuiper'
import { DotLoader } from '@opallabs/lapidary'
import { PreviewSettings } from '../PreviewSettings'
import { styles } from './styles'

interface Props {
  embeddedUrl: string | null
  embedlyPreview: string | null
  isPresenting: boolean
  onEmbeddedUrlChange: (val: string) => void
  onSnapshotUrlChange: (val: string) => void
  onRefreshChange: (val: string) => void
  snapshotUrl: string | null
  readOnly: boolean
  refreshedAt: string
}

export const PreviewDisplay: React.FC<Props> = ({
  embeddedUrl,
  embedlyPreview,
  isPresenting,
  onEmbeddedUrlChange,
  onSnapshotUrlChange,
  onRefreshChange,
  snapshotUrl,
  readOnly,
  refreshedAt,
}) => {
  const [tooltipActive, setTooltipActive] = useState(false)
  const [imageLoading, setImageLoading] = useState(true)

  const onImageLoad = () => {
    setImageLoading(false)
  }

  return (
    <div css={styles.getPreviewWrapper(tooltipActive)}>
      <div className={kuiperClassNames('preview-wrapper')}>
        <div css={styles.getPreview(!snapshotUrl)}>
          {snapshotUrl && typeof snapshotUrl === 'string' && (
            <div>
              {imageLoading && (
                <div css={styles.loaderWrapper}>
                  <DotLoader />
                </div>
              )}
              <img
                src={snapshotUrl}
                alt="Repost Snapshot"
                onLoad={onImageLoad}
                width="100%"
              />
            </div>
          )}
          {!snapshotUrl && (
            <div>
              <div className={kuiperClassNames('embedly-preview-wrapper')}>
                {embedlyPreview ? convertHtmlToReact(embedlyPreview) : null}
              </div>
            </div>
          )}
        </div>
        {!(readOnly || isPresenting) && (
          <div
            css={styles.settingsIconWrapper}
            className={kuiperClassNames('settings-icon-wrapper')}
          >
            <div
              css={styles.settingsIcon}
              className={kuiperClassNames('settings-icon-wrapper-trigger')}
            >
              <PopoverV2
                className="content-preview-settings-popover"
                onOpen={() => setTooltipActive(true)}
                onClose={() => setTooltipActive(false)}
                trigger={renderIcon('cog-lg', {
                  ariaLabel: 'Content Preview Settings Popover Icon Trigger',
                })}
                content={
                  <PreviewSettings
                    url={embeddedUrl as string}
                    refreshedAt={refreshedAt}
                    onRefreshChange={onRefreshChange}
                    onEmbeddedUrlChange={onEmbeddedUrlChange}
                    onSnapshotUrlChange={onSnapshotUrlChange}
                  />
                }
              />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
